import countries from './static/countries';
import states from './static/states';

export const getCountryIdByCode = (code: string): number | undefined =>
  countries.find(country => country.code === code)?.id;

export const getStateIdByCode = (code: string): number | undefined =>
  states.find(state => state.code === code)?.id;
